import OTPInput from 'react-otp-input'

interface Props {
    code : string,
    handleChange : any
}

export const OtpInput = ({code, handleChange} : Props) =>{
    return (
        <div className='d-flex justify-content-center mb-8'>
        <div>
          <OTPInput
            value={code}
            onChange={handleChange}
            numInputs={6}
            shouldAutoFocus={true}
            separator={<span style={{width: '16px'}}></span>}
            isInputNum={true}
            inputStyle={{
              borderRadius: '8px',
              width: '50px',
              height: '60px',
              border: '1px solid #CFD3DB',
              outline: 'none',
            }}
            focusStyle={{
              border: '1px solid grey',
              outline: 'none',
            }}
          />
        </div>
      </div>
    )
}
